// removed by extract-text-webpack-plugin
module.exports = {"qualTblScrollCnt":"styles__qualTblScrollCnt___3v9gi","view-more-btn":"styles__view-more-btn___3iwVG","QualTableBody":"styles__QualTableBody___1t7f3","row":"styles__row___1rKe_","cell":"styles__cell___8wjOh","timestamp":"styles__timestamp___3YFvx","panelists":"styles__panelists___lyOYn","media":"styles__media___jmQ_M","comment":"styles__comment___2jSm4","likes":"styles__likes___v2v-h","tags":"styles__tags___3GGK9","sentiments":"styles__sentiments___1fRNL","odd":"styles__odd___1RyMy","even":"styles__even___2PW-9","content":"styles__content___293bl"};


//////////////////
// WEBPACK FOOTER
// ./components/qual/Table/TableBody/styles.scss
// module id = QZZK
// module chunks = 0